import { Card, Divider, Grid, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import FormButtonOptions from '../../../FormFields/FormButtonOptions';
import FormDataDivider from '../../../FormFields/FormDataDivider';
import FormFileDrop from '../../../FormFields/FormFileDrop';
import FormTextField from '../../../FormFields/FormTextField';
import FieldContainer from '../../../FormFields/FieldContainer';
import FormTitle from '../../../FormFields/FormTitle';
import { ENVIRONMENTAL } from '../../../formQuestionsEnum';
import { formCardStyle } from '../../../TransitionStyles';
import { FILE_TYPES } from '../../../formFileTypesEnum';
import Dryer from './Dryer';
import Equipment from './Equipment';
import HeatPress from './HeatPress';
import WashingMachine from './WashingMachine';

LaundryForm.propTypes = {
  permissions: PropTypes.object,
};

export default function LaundryForm({ permissions }) {
  const [focusedField, setFocusedField] = useState(null);

  const fieldIds = [
    ENVIRONMENTAL.LAUNDRY_IS_OUTSOURCED.id,
    ENVIRONMENTAL.LAUNDRY_STAFFING_SCHEDULE.id,
    ENVIRONMENTAL.LAUNDRY_EQUIPMENT.id,
    ENVIRONMENTAL.WASHING_MACHINES.id,
    ENVIRONMENTAL.DRYERS.id,
    ENVIRONMENTAL.HEAT_PRESSES.id,
    ENVIRONMENTAL.CHEMICALS.id,
    ENVIRONMENTAL.LINENS.id,
  ];

  const showForm = fieldIds.some((id) => id in permissions);

  return (
    showForm && (
      <Card sx={formCardStyle}>
        <Typography sx={{ mb: 1 }} align="center" variant="body1" color="info.main">
          Laundry
        </Typography>
        <Divider sx={{ mb: 1, mt: 2, borderWidth: 1 }} />

        <Grid container spacing={1.5}>
          {ENVIRONMENTAL.LAUNDRY_IS_OUTSOURCED.id in permissions && (
            <Grid item xs={12}>
              <FormTitle fieldAttributes={{ questionTitle: 'Laundry' }} />
              <FormButtonOptions
                fieldName={ENVIRONMENTAL.LAUNDRY_IS_OUTSOURCED.fieldName}
                fieldAttributes={{
                  isEditable: permissions[ENVIRONMENTAL.LAUNDRY_IS_OUTSOURCED.id],
                  options: [
                    { label: 'Outsourced', value: true },
                    { label: 'In House', value: false },
                  ],
                }}
              />
            </Grid>
          )}

          {ENVIRONMENTAL.LAUNDRY_STAFFING_SCHEDULE.id in permissions && (
            <Grid item xs={12}>
              <FormTitle fieldAttributes={{ questionTitle: 'Laundry staffing schedule', fieldType: 'file' }} />
              <FormFileDrop
                fieldName={ENVIRONMENTAL.LAUNDRY_STAFFING_SCHEDULE.fieldName}
                fieldAttributes={{
                  isEditable: permissions[ENVIRONMENTAL.LAUNDRY_STAFFING_SCHEDULE.id],
                  fileTypeId: FILE_TYPES.LAUNDRY_STAFFING_SCHEDULE,
                }}
              />
            </Grid>
          )}

          {ENVIRONMENTAL.LAUNDRY_EQUIPMENT.id in permissions && (
            <Grid container spacing={1.5} item xs={12}>
              <Grid item xs={12}>
                <FormTitle fieldAttributes={{ questionTitle: 'Laundry equipment', fieldType: 'title' }} />
              </Grid>
              <Grid item xs={12}>
                <Equipment
                  isEditable={permissions[ENVIRONMENTAL.LAUNDRY_EQUIPMENT.id]}
                  equipmentsFieldName={ENVIRONMENTAL.LAUNDRY_EQUIPMENT.fieldName}
                />
              </Grid>
              <FormDataDivider />
            </Grid>
          )}

          {ENVIRONMENTAL.WASHING_MACHINES.id in permissions && (
            <Grid container spacing={1.5} item xs={12}>
              <Grid item xs={12}>
                <FormTitle fieldAttributes={{ questionTitle: 'Washing machine', fieldType: 'title' }} />
              </Grid>
              <Grid item xs={12}>
                <WashingMachine isEditable={permissions[ENVIRONMENTAL.WASHING_MACHINES.id]} />
              </Grid>
              <FormDataDivider />
            </Grid>
          )}

          {ENVIRONMENTAL.DRYERS.id in permissions && (
            <Grid container spacing={1.5} item xs={12}>
              <Grid item xs={12}>
                <FormTitle fieldAttributes={{ questionTitle: 'Dryer', fieldType: 'title' }} />
              </Grid>
              <Grid item xs={12}>
                <Dryer isEditable={permissions[ENVIRONMENTAL.DRYERS.id]} />
              </Grid>
              <FormDataDivider />
            </Grid>
          )}

          {ENVIRONMENTAL.HEAT_PRESSES.id in permissions && (
            <Grid container spacing={1.5} item xs={12}>
              <Grid item xs={12}>
                <FormTitle fieldAttributes={{ questionTitle: 'Heat press', fieldType: 'title' }} />
              </Grid>
              <Grid item xs={12}>
                <HeatPress isEditable={permissions[ENVIRONMENTAL.HEAT_PRESSES.id]} />
              </Grid>
              <FormDataDivider />
            </Grid>
          )}

          {ENVIRONMENTAL.CHEMICALS.id in permissions && (
            <Grid item xs={6}>
              <FieldContainer>
                <FormTitle fieldAttributes={{ questionTitle: 'List chemicals' }} />
                <FormTextField
                  fieldName={ENVIRONMENTAL.CHEMICALS.fieldName}
                  fieldAttributes={{ isEditable: permissions[ENVIRONMENTAL.CHEMICALS.id] }}
                  focusedField={focusedField}
                  setFocusedField={setFocusedField}
                  multiline
                />
              </FieldContainer>
            </Grid>
          )}

          {ENVIRONMENTAL.LINENS.id in permissions && (
            <Grid item xs={6}>
              <FieldContainer>
                <FormTitle fieldAttributes={{ questionTitle: 'List linens' }} />
                <FormTextField
                  fieldName={ENVIRONMENTAL.LINENS.fieldName}
                  fieldAttributes={{ isEditable: permissions[ENVIRONMENTAL.LINENS.id] }}
                  focusedField={focusedField}
                  setFocusedField={setFocusedField}
                  multiline
                />
              </FieldContainer>
            </Grid>
          )}
        </Grid>
      </Card>
    )
  );
}
